export const newServiceOrderActionTypes = {
  setServiceOrderObservations: '[Service Order] Set service order observations',
  addServiceOrderSpecialRequest:
    '[Service Order] Add service order special request',
  setServiceOrderAlternativeOwner:
    '[Service Order] Add service order alternative owner',
  setServiceOrderPromiseDate: '[Service Order] set service order promise date',
  updateServiceOrderCreatedDate:
    '[Service Order] update service order created date',
  changeServiceOrderCompletionType:
    '[Service Order] Change service order completion type',
  removeServiceOrderSpecialRequest:
    '[Service Order] Remove service order special request',
  openServiceOrderEditVehicleModal:
    '[Service Order] Open service order edit vehicle modal',
  closeServiceOrderEditVehicleModal:
    '[Service Order] close service order edit vehicle modal',
  setServiceOrderSelectedVendor:
    '[Service Order] Set service order selected vendor',
  clearServiceOrder: '[Service Order] Clear service order',
  discardServiceOrder: '[Service Order] Discard service order',
  clearServiceOrderError: '[Service Order] Clear service order error',
  addPriceToSelectedServiceOrderPrices:
    '[Service Order] Add price to selected service order prices',
  removePriceToSelectedServiceOrderPrices:
    '[Service Order] Remove price to selected service order prices',
  getServiceOrderVendors: '[Service Order] Get service order vendors async',
  getServiceOrderServicesByDepartment:
    '[Service Order] Get service order services by department',
  getServiceOrderVehicleByVin:
    '[Service Order] Get service order vehicle by vin',
  saveServiceOrder: '[Service Order] Save service order',
  editServiceOrderVehicleDetails:
    '[Service Order] Edit service order vehicle details',
  addServiceOrderVehicleDetails:
    '[Service Order] Add service order vehicle details',
  serviceOrderAlternativeOwner:
    '[Service Order] Service order alternative owner',
  setServiceOrderSelectedServicesPrices:
    '[ServiceOrder] Set selected services prices for service order',
  setServiceOrderServicesComplianceTime:
    '[ServiceOrder] Set selected services Services Compliance Time',
  setAllServiceOrderDealers: '[NewOrder] Set all dealers',
  setVehicleStockNumber:
    '[ServiceOrder] Set selected vehicle details stock number',
};
